import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';

import { Header } from './project.page';
import { uiStore } from '../../core/stores/ui-store';
import { ShareLinkList } from '../../features/share/components/share-link-list';
import { ScreenContainer } from '../../features/projects/components/styled-project-components';

import styles from './project-share-links.route.module.scss';
export const ProjectShareLinksRoute = observer(() => {
  useEffect(() => {
    uiStore.currentLocation = 'project.share-links';

    return () => {
      uiStore.currentLocation = '';
    };
  }, []);

  return (
    <React.Suspense>
      <Header>Share links</Header>

      <ScreenContainer>
        <div className={styles['container']}>
          <ShareLinkList />
        </div>
      </ScreenContainer>
    </React.Suspense>
  );
});
